import Axios from "axios";
import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import AppConfig from "../../../../../config/AppConfig";
class ChartSebaranPTVBerdasarkanKategori extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: [],
      politeknik_negeri: [],
      politeknik_swasta: [],
      // politeknik_kedinasan: [],
      akademi_negeri: [],
      akademi_swasta: [],
      // akademi_kedinasan: [],
      ak_negeri: [],
      ak_swasta: [],
      // ak_kedinasan: [],
      st_negeri: [],
      st_swasta: [],

      institut_negeri: [],
      institut_swasta: [],

      universitas_negeri: [],
      universitas_swasta: [],
      loading: false,
    };
  }

  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };
  getData() {
    this.setState({
      loading: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let i = 0;
    let labels = [];
    let politeknik_negeri = [];
    let politeknik_swasta = [];
    // let politeknik_kedinasan = [];
    let akademi_negeri = [];
    let akademi_swasta = [];
    // let akademi_kedinasan = [];
    let ak_negeri = [];
    let ak_swasta = [];
    // let ak_kedinasan = [];
    let st_negeri = [];
    let st_swasta = [];
    
    let institut_negeri = [];
    let institut_swasta = [];
    
    let universitas_negeri = [];
    let universitas_swasta = [];

    Axios.get(AppConfig.DetailDashboard + "sebaranptvbykategori" + session)
      .then((res) => {
        for (var key in res.data.result.data_belmawa) {
          labels[i] = key;
          politeknik_negeri[i] = res.data.result.data_belmawa[key].politeknik_negeri;
          politeknik_swasta[i] = res.data.result.data_belmawa[key].politeknik_swasta;
          // politeknik_kedinasan[i] =
          //   res.data.result.data[key].politeknik_kedinasan;
          akademi_negeri[i] = res.data.result.data_belmawa[key].akademi_negeri;
          akademi_swasta[i] = res.data.result.data_belmawa[key].akademi_swasta;
          // akademi_kedinasan[i] = res.data.result.data[key].akademi_kedinasan;
          ak_negeri[i] = res.data.result.data_belmawa[key].ak_negeri;
          ak_swasta[i] = res.data.result.data_belmawa[key].ak_swasta;
          // ak_kedinasan[i] = res.data.result.data[key].ak_kedinasan;
          st_negeri[i] = res.data.result.data_belmawa[key].st_negeri;
          st_swasta[i] = res.data.result.data_belmawa[key].st_swasta;
          
          institut_negeri[i] = res.data.result.data_belmawa[key].institut_negeri;
          institut_swasta[i] = res.data.result.data_belmawa[key].institut_swasta;
          
          universitas_negeri[i] = res.data.result.data_belmawa[key].universitas_negeri;
          universitas_swasta[i] = res.data.result.data_belmawa[key].universitas_swasta;
          i = i + 1;
        }

        this.setState({
          label: labels,
          politeknik_negeri: politeknik_negeri,
          politeknik_swasta: politeknik_swasta,
          // politeknik_kedinasan: politeknik_kedinasan,
          akademi_negeri: akademi_negeri,
          akademi_swasta: akademi_swasta,
          // akademi_kedinasan: akademi_kedinasan,
          ak_negeri: ak_negeri,
          ak_swasta: ak_swasta,
          // ak_kedinasan: ak_kedinasan,
          st_negeri: st_negeri,
          st_swasta: st_swasta,
          
          institut_negeri: institut_negeri,
          institut_swasta: institut_swasta,
          
          universitas_negeri: universitas_negeri,
          universitas_swasta: universitas_swasta,
          loading: false,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getData();
  }
  async componentDidUpdate() {
    if (this.props.status === true) {
      this.getData();
      this.props.parentCallback(false);
    }
  }
  render() {
    let datas = {
      labels: this.state.label,
      datasets: [
        {
          label: "Politeknik Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#EB318C",
          borderColor: "#EB318C",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#EB318C",
          pointBackgroundColor: "#EB318C",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#EB318C",
          pointHoverBorderColor: "#EB318C",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.politeknik_negeri,
        },
        {
          label: "Politeknik Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F533F3",
          borderColor: "#F533F3",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F533F3",
          pointBackgroundColor: "#F533F3",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F533F3",
          pointHoverBorderColor: "#F533F3",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.politeknik_swasta,
        },
        // {
        //   label: "Politeknik Kedinasan",
        //   fill: false,
        //   lineTension: 0.1,
        //   backgroundColor: "#BCD8FF",
        //   borderColor: "#BCD8FF",
        //   borderCapStyle: "butt",
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   borderJoinStyle: "miter",
        //   pointBorderColor: "#BCD8FF",
        //   pointBackgroundColor: "#BCD8FF",
        //   pointBorderWidth: 1,
        //   pointHoverRadius: 5,
        //   pointHoverBackgroundColor: "#BCD8FF",
        //   pointHoverBorderColor: "#BCD8FF",
        //   pointHoverBorderWidth: 2,
        //   pointRadius: 1,
        //   pointHitRadius: 10,
        //   data: this.state.politeknik_kedinasan,
        // },
        {
          label: "Akademi Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#B23ADE",
          borderColor: "#B23ADE",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#B23ADE",
          pointBackgroundColor: "#B23ADE",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#B23ADE",
          pointHoverBorderColor: "#B23ADE",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.akademi_negeri,
        },
        {
          label: "Akademi Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#8C33F5",
          borderColor: "#8C33F5",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#8C33F5",
          pointBackgroundColor: "#8C33F5",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#8C33F5",
          pointHoverBorderColor: "#8C33F5",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.akademi_swasta,
        },
        // {
        //   label: "Akademi Kedinasan",
        //   fill: false,
        //   lineTension: 0.1,
        //   backgroundColor: "#FFC3AB",
        //   borderColor: "#FFC3AB",
        //   borderCapStyle: "butt",
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   borderJoinStyle: "miter",
        //   pointBorderColor: "#FFC3AB",
        //   pointBackgroundColor: "#FFC3AB",
        //   pointBorderWidth: 1,
        //   pointHoverRadius: 5,
        //   pointHoverBackgroundColor: "#FFC3AB",
        //   pointHoverBorderColor: "#FFC3AB",
        //   pointHoverBorderWidth: 2,
        //   pointRadius: 1,
        //   pointHitRadius: 10,
        //   data: this.state.akademi_kedinasan,
        // },
        {
          label: "AK Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#5431EB",
          borderColor: "#5431EB",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#5431EB",
          pointBackgroundColor: "#5431EB",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#5431EB",
          pointHoverBorderColor: "#5431EB",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.ak_negeri,
        },
        {
          label: "AK Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#EDB034",
          borderColor: "#EDB034",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#EDB034",
          pointBackgroundColor: "#EDB034",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#EDB034",
          pointHoverBorderColor: "#EDB034",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.ak_swasta,
        },
        // {
        //   label: "AK Kedinasan",
        //   fill: false,
        //   lineTension: 0.1,
        //   backgroundColor: "#FFF7C7",
        //   borderColor: "#FFF7C7",
        //   borderCapStyle: "butt",
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   borderJoinStyle: "miter",
        //   pointBorderColor: "#FFF7C7",
        //   pointBackgroundColor: "#FFF7C7",
        //   pointBorderWidth: 1,
        //   pointHoverRadius: 5,
        //   pointHoverBackgroundColor: "#FFF7C7",
        //   pointHoverBorderColor: "#FFF7C7",
        //   pointHoverBorderWidth: 2,
        //   pointRadius: 1,
        //   pointHitRadius: 10,
        //   data: this.state.ak_kedinasan,
        // },
        {
          label: "Sekolah Tinggi Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F7A336",
          borderColor: "#F7A336",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F7A336",
          pointBackgroundColor: "#F7A336",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F7A336",
          pointHoverBorderColor: "#F7A336",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.st_swasta,
        },
        {
          label: "Sekolah Tinggi Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#E0803D",
          borderColor: "#E0803D",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#E0803D",
          pointBackgroundColor: "#E0803D",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#E0803D",
          pointHoverBorderColor: "#E0803D",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.st_negeri,
        },
        {
          label: "Institut Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F76B36",
          borderColor: "#F76B36",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F76B36",
          pointBackgroundColor: "#F76B36",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F76B36",
          pointHoverBorderColor: "#F76B36",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.institut_swasta,
        },
        {
          label: "Institut Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#ED4B34",
          borderColor: "#ED4B34",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ED4B34",
          pointBackgroundColor: "#ED4B34",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ED4B34",
          pointHoverBorderColor: "#ED4B34",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.institut_negeri,
        },
        {
          label: "Universitas Negeri",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#8DE02D",
          borderColor: "#8DE02D",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#8DE02D",
          pointBackgroundColor: "#8DE02D",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#8DE02D",
          pointHoverBorderColor: "#8DE02D",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.universitas_swasta,
        },
        {
          label: "Universitas Swasta",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#DFF725",
          borderColor: "#DFF725",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#DFF725",
          pointBackgroundColor: "#DFF725",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#DFF725",
          pointHoverBorderColor: "#DFF725",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.universitas_negeri,
        },
      ],
    };
    return (
      <>
        {this.state.loading === true ? (
          <span className="ml-3 spinner spinner-black"></span>
        ) : (
          <Bar data={datas} options={this.options} />
        )}
      </>
    );
  }
}
export default ChartSebaranPTVBerdasarkanKategori;
